<!-- <div class="content-wrapper container-xxl p-0"> -->
<div class="content-wrapper">
	<div class="content-body">
		<!-- content-header component -->
		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<section id="sample-page">
			<div class="row">
				<div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
				<div class="col-12">
					<div class="card">
						<div class="card-body pb-1">
							<form #cadastroForm="ngForm">
								<div class="card-body pb-1">

									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label>Nome</label>
											<input [(ngModel)]="nome" #nomeRef="ngModel" class="form-ngModel" required
												type="text" name="nome" class="form-control"
												[class.error]="!nomeRef.valid && cadastroForm.submitted"
												placeholder="Nome Completo" />
											<span *ngIf="cadastroForm.submitted && nomeRef.invalid"
												class="invalid-form">
												<small class="form-text text-danger" *ngIf="nomeRef.errors.required">
													Campo Obrigatório!
												</small>
											</span>
										</div>
									</div>

									<div class="col-md-6 col-12">
										<div class="form-group mb-2">

											<label for="basicSelect">Status</label>
											<select [(ngModel)]="status" #statusRef="ngModel" name="status"
												class="form-control" id="basicSelect" required>
												<option value="0">Ativo</option>
												<option value="1">Inativo</option>
											</select>
											<span *ngIf="cadastroForm.submitted && statusRef.invalid"
												class="invalid-form">
												<small class="form-text text-danger" *ngIf="statusRef.errors.required">
													Selecione uma opção!
												</small>
											</span>

										</div>
									</div>

									<div class="col-12 mt-50 ">
										<button routerLink="/sistema/" class="btn btn-secondary botao-cancelar"
											rippleEffect>Cancelar</button>

										<button (click)="submitForm(cadastroForm)" type="submit"
											class="btn btn-primary btn-next " rippleEffect>
											<span class="align-middle d-sm-inline-block d-none">Salvar</span>
											<i data-feather="arrow-right"
												class="isHidden align-middle ml-sm-25 ml-0"></i>
											<span class="spinner-border-sm align-middle ml-sm-25 ml-0" role="status"
												aria-hidden="true"></span>
										</button>
										<br>
										<br>
										<div *ngIf="isLoading" class="spinner-border"></div>
									</div>

								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>

	</div>
</div>